



















































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Typography, Surface } from '@/components/atoms';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import TogglesIcon from '@/components/icons/Toggles.vue';
import FormHeader from '@/componentsV2/molecules/FormHeader/FormHeader.vue';

@Component({
  components: {
    Typography,
    Surface,
    Checkbox,
    TogglesIcon,
    FormHeader
  }
})
export default class OfferFreeCoinsCustomerSettings extends Vue {
  @Prop({ default: false }) readonly value!: string;
}
